import React, { useState } from 'react';
// @ts-ignore
import DOMPurify from 'dompurify';
import { JobSource, FormErrors } from '../types';

interface WriterArticleSectionProps {
  formData: JobSource;
  setFormData: React.Dispatch<React.SetStateAction<JobSource>>;
  errors: FormErrors;
}

/**
 * HTMLプレビューコンポーネント
 */
const HtmlPreview: React.FC<{ html: string }> = ({ html }) => {
  const sanitizedHtml = DOMPurify.sanitize(html || '');
  
  return (
    <div 
      className="blog-content border rounded p-3 bg-white" 
      style={{ 
        minHeight: '400px', 
        maxHeight: '600px', 
        overflowY: 'auto',
        color: '#222222'
      }}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

/**
 * HTML入力フィールドコンポーネント
 */
const HtmlInputField: React.FC<{
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  helpText: string;
  errors?: string[];
}> = ({ id, label, value, onChange, placeholder, helpText, errors }) => {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <div className="form-group mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <label htmlFor={id} className="form-label fw-semibold mb-0">
          {label}
        </label>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={() => setShowPreview(!showPreview)}
        >
          {showPreview ? '編集' : 'プレビュー'}
        </button>
      </div>
      {showPreview ? (
        <HtmlPreview html={value} />
      ) : (
        <textarea
          id={id}
          className={`form-control ${errors && errors.length > 0 ? 'is-invalid' : ''}`}
          rows={20}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
      )}
      {errors && errors.length > 0 && (
        <div className="invalid-feedback d-block">
          {errors.join(', ')}
        </div>
      )}
      <small className="form-text text-muted">
        {helpText}
      </small>
    </div>
  );
};

const WriterArticleSection: React.FC<WriterArticleSectionProps> = ({
  formData,
  setFormData,
  errors,
}) => {
  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  return (
    <div>
      <HtmlInputField
        id="writer_article"
        label="ライター解説"
        value={formData.writer_article || ''}
        onChange={handleChange('writer_article')}
        placeholder="ライター解説をHTML形式で直接入力してください"
        helpText="エージェントの詳細な解説をHTML形式で直接入力してください。プレビューボタンで表示を確認できます。"
        errors={errors.writer_article}
      />

      <HtmlInputField
        id="margin_article"
        label="マージン率・手数料（ブログ用記事）"
        value={formData.margin_article || ''}
        onChange={handleChange('margin_article')}
        placeholder="マージン率・手数料に関するブログ記事をHTML形式で入力してください"
        helpText="ライターが書くブログ記事をHTML形式で入力してください。プレビューボタンで表示を確認できます。"
        errors={errors.margin_article}
      />

      <HtmlInputField
        id="payment_site_article"
        label="支払いサイト（ブログ用記事）"
        value={formData.payment_site_article || ''}
        onChange={handleChange('payment_site_article')}
        placeholder="支払いサイトに関するブログ記事をHTML形式で入力してください"
        helpText="ライターが書くブログ記事をHTML形式で入力してください。プレビューボタンで表示を確認できます。"
        errors={errors.payment_site_article}
      />

      <HtmlInputField
        id="sidework_article"
        label="副業（ブログ用記事）"
        value={formData.sidework_article || ''}
        onChange={handleChange('sidework_article')}
        placeholder="副業に関するブログ記事をHTML形式で入力してください"
        helpText="ライターが書くブログ記事をHTML形式で入力してください。プレビューボタンで表示を確認できます。"
        errors={errors.sidework_article}
      />
    </div>
  );
};

export default WriterArticleSection;
